import React, {Fragment} from "react";
import {Button, Col, Dropdown, Icon, Menu, Row} from "antd";
import PingIcon from "../ping-icon";
import {GUTTER_SM, MARGIN_XS} from "../../styles/constants";

const EndpointsDropdown = ({
                             endpoints,
                             endpointId,
                             isEndpointAvailable,
                             onEndpointSet,
                             onNodePing,
                             disabled,
                             canBeNull,
                             fullWidth,
                             doNotGoHome
                           }) =>
  endpoints && endpoints.length > 0 && (endpointId || canBeNull)
    ? (
      <Fragment>
        <Dropdown
          disabled={disabled}
          trigger={['hover']}
          overlay={
            <Menu
              onClick={
                ({key}) => {
                  if(!doNotGoHome) {
                    window.open('./#', '_self');
                  }
                  onEndpointSet(key);
                }
              }
            >
              {endpoints.map(endpoint =>
                <Menu.Item key={endpoint.general.id}>
                  <a>{endpoint.general.name} ({endpoint.general.id})</a>
                </Menu.Item>
              )}
            </Menu>
          }
        >
          <Button htmlType="button" style={fullWidth ? {width: "calc(100% - 36px)"} : undefined}>
            <Row justify={endpointId ? "space-between" : "end"} gutter={GUTTER_SM} type="flex">
              {endpointId && (
                <Col>
                  <Row type="flex" gutter={GUTTER_SM}>
                    <Col>
                      <PingIcon isOk={isEndpointAvailable}/>
                    </Col>
                    <Col>
                      {!!endpoints.find(endpoint => endpoint.general.id === endpointId)
                        ? endpoints.find(endpoint => endpoint.general.id === endpointId).general.name
                        : endpointId
                      }
                    </Col>
                  </Row>
                </Col>
              )}
              <Col>
                <Icon type="down"/>
              </Col>
            </Row>
          </Button>
        </Dropdown>
        <Button icon="sync" style={{marginLeft: MARGIN_XS}} onClick={onNodePing} disabled={disabled}/>
      </Fragment>
    )
    : null;

export default EndpointsDropdown;


// WEBPACK FOOTER //
// ./src/components/endpoints-dropdown/index.jsx